<template>
  <div class="flex flex-row flex-wrap items-center justify-evenly gap-4">
    <WebccButton
      v-for="value in [1, 2, 3]"
      :key="value"
      :variant="fuzziness === value ? 'grey' : 'white'"
      outline
      class="w-[6.5rem] py-2.5 text-center font-medium focus:border-thm-hover focus:ring-thm-hover md:w-auto md:py-2"
      @click="fuzziness = value"
    >
      &plusmn; {{ $t(`${trPrefix}night_s`, {}, value) }}
    </WebccButton>
  </div>
</template>

<script setup lang="ts">
const trPrefix = 'www.components.elements.FlexibleDates.'

const fuzziness = defineModel<number | undefined>({ required: true })
</script>
